import { BrandVoicesStore, useCurrentWorkspace, useIsCurrentUserAdmin } from 'src/store';
import { createStateSelectorHook } from 'src/lib/sweetState';

const useBrandVoicesState = createStateSelectorHook(BrandVoicesStore, ['brandVoices']);

export const useSidebarBrandVoices = () => {
  const currentWorkspace = useCurrentWorkspace();
  const { brandVoices } = useBrandVoicesState();
  const isCurrentUserAdmin = useIsCurrentUserAdmin();

  if (isCurrentUserAdmin) {
    return brandVoices;
  } else {
    return currentWorkspace?.associatedBrandVoices || [];
  }
};
